import Category from 'umg-ember-backend/components/record-explorer/for/category';

<template><Category @records={{@model}} @recordType='category' /></template>
